import PropTypes from 'prop-types';
import React from 'react';

import { athenaUrl } from '../../helpers';
import styles from './AthenaLink.module.scss';

const AthenaLink = ({ integration }) => {
  const resolvedIntegration = integration ?? null;
  const athenaPatientId = resolvedIntegration?.athenaPatientId;
  const href = athenaUrl(athenaPatientId, resolvedIntegration?.practiceId);
  const hasLink = Boolean(href);
  const displayId = athenaPatientId ?? '—';

  return (
    <a
      className={`${styles.link} ${hasLink ? '' : styles.disabled}`}
      href={href}
      target={hasLink ? '_blank' : undefined}
      rel={hasLink ? 'noopener noreferrer' : undefined}
      aria-disabled={!hasLink}
      onClick={(e) => {
        if (!hasLink) e.preventDefault();
      }}
    >
      <div className={styles.badge}>
        <span className={styles.badgeText}>A</span>
      </div>
      <div className={styles.meta}>
        <span className={styles.title}>Open in Athena</span>
        <span className={styles.mrn}>{displayId}</span>
      </div>
      <span className={styles.arrow} aria-hidden="true">
        ↗
      </span>
    </a>
  );
};

AthenaLink.propTypes = {
  integration: PropTypes.shape({
    athenaPatientId: PropTypes.string,
    practiceId: PropTypes.string,
  }),
};

export default AthenaLink;
